import { render, staticRenderFns } from "./LoginX.vue?vue&type=template&id=1e9609d9&scoped=true&"
import script from "./LoginX.vue?vue&type=script&lang=js&"
export * from "./LoginX.vue?vue&type=script&lang=js&"
import style0 from "./LoginX.vue?vue&type=style&index=0&id=1e9609d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9609d9",
  null
  
)

export default component.exports